import { render, staticRenderFns } from "./SafetyStatistic.vue?vue&type=template&id=0e784b76&scoped=true"
import script from "./SafetyStatistic.vue?vue&type=script&lang=js"
export * from "./SafetyStatistic.vue?vue&type=script&lang=js"
import style0 from "./SafetyStatistic.vue?vue&type=style&index=0&id=0e784b76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e784b76",
  null
  
)

export default component.exports